
import styled from 'styled-components';
import search_icon from "../../imgs/search_icon.svg";
import search_icon_light from "../../imgs/search_icon_light.svg";
import React from 'react';

interface SearchInputProps {
    onTextChange: (text: string) => void;
    theme: string;
    placeholder?: string;
  }

const SearchIcon = styled.img`
  padding-left: 20px;
  width: 20px;
  height: 20px;
`;

const SearchBarContainer = styled("div")`
align-self: center;
display: flex;
flex-direction: row;
align-items: center;
overflow: hidden;
padding: 0.5rem;
background: rgba(193, 193, 193, 0.2);
border: ${(props) => props.theme.themeType=== "dark" ? "" : "1px solid #702EFF"};
border-radius: 10px;
width: 90%;
`;

const SearchBar = styled("input")`
  outline: none;
  border: none;
  background: none;
  font-size: 0.8em;
  padding: 0.3rem;
  color: ${(props) => (props.theme.themeType === "dark" ? "white" : "black")};
  width: 100%;
  font-family: "Spartan";

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${(props) => (props.theme.themeType === "dark" ? "rgba(255, 255, 255, 0.7)" : "black")};
    opacity: 1; /* Firefox */
  }
`;
const SearchInput = ({ onTextChange, theme, placeholder }: SearchInputProps) => {
    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      onTextChange(event.target.value);
    };
  
    return (
        <SearchBarContainer>
          <SearchIcon src={theme === "dark" ? search_icon : search_icon_light} />
          <SearchBar
            onChange={onInputChange}
            placeholder={placeholder ? placeholder :"Search by keyword"}
          />
        </SearchBarContainer>
    );
  };

  export default SearchInput;